export const PROVINCES = [
	"Ilocos Norte",
	"Ilocos Sur",
	"La Union",
	"Pangasinan",
	"Batanes",
	"Cagayan",
	"Isabela",
	"Nueva Vizcaya",
	"Quirino",
	"Bataan",
	"Bulacan",
	"Nueva Ecija",
	"Pampanga",
	"Tarlac",
	"Zambales",
	"Aurora",
	"Batangas",
	"Cavite",
	"Laguna",
	"Quezon",
	"Rizal",
	"Albay",
	"Camarines Norte",
	"Camarines Sur",
	"Catanduanes",
	"Masbate",
	"Sorsogon",
	"Aklan",
	"Antique",
	"Capiz",
	"Iloilo",
	"Negros Occidental",
	"Guimaras",
	"Bohol",
	"Cebu",
	"Negros Oriental",
	"Siquijor",
	"Eastern Samar",
	"Leyte",
	"Northern Samar",
	"Samar (Western Samar)",
	"Southern Leyte",
	"Biliran",
	"Zamboanga del Norte",
	"Zamboanga del Sur",
	"Zamboanga Sibugay",
	"City of Isabela",
	"Bukidnon",
	"Camiguin",
	"Lanao del Norte",
	"Misamis Occidental",
	"Misamis Oriental",
	"Davao del Norte",
	"Davao del Sur",
	"Davao Oriental",
	"Davao de Oro (Compostela Valley)",
	"Davao Occidental",
	"Cotabato (North Cotabato)",
	"South Cotabato",
	"Sultan Kudarat",
	"Sarangani",
	"Metropolitan Manila First District",
	"Metropolitan Manila Second District",
	"Metropolitan Manila Third District",
	"Metropolitan Manila Fourth District",
	"Abra",
	"Benguet",
	"Ifugao",
	"Kalinga",
	"Mountain Province",
	"Apayao",
	"Agusan del Norte",
	"Agusan del Sur",
	"Surigao del Norte",
	"Surigao del Sur",
	"Dinagat Islands",
	"Marinduque",
	"Occidental Mindoro",
	"Oriental Mindoro",
	"Palawan",
	"Romblon",
	"Basilan",
	"Lanao del Sur",
	"Sulu",
	"Tawi-Tawi",
	"Maguindanao del Norte",
	"Maguindanao del Sur",
	"Special Geographic Area",
];

export const REGION_INDEX_TO_PROVINCE_INDEX = [
    [0], [1], [2], [3], [4], [5], [6], [7], [8], [9], [10], [11], [12], [13], [14], [15], [16], [17], [18], [19],
    [20], [21], [22], [23], [24], [25], [26], [27], [28], [29], [30], [31], [32], [33], [34], [35], [36], [37],
    [38], [39], [40], [41], [42], [43], [44], [45], [46], [47], [48], [49], [50], [51], [52], [53], [54], [55],
    [56], [57], [58], [59], [60], [61], [62], [63], [64], [65], [66], [67], [68], [69], [70], [71], [72], [73],
    [74], [75], [76], [77], [78], [79], [80], [81], [82], [83], [84], [85], [86], [87],
];

/*
Province bitflag
0x1: Illocos Region 0
0x2: Cagayan Valley 1
0x4: Central Luzon 2
0x8: Calabarzon 3
0x10: Bicol Region 4
0x20: Western Visayas 5
0x40: Central Visayas 6
0x80: Eastern Visayas 7
0x100: Zamboanga Peninsula 8
0x200: Northern Mindanao 9
0x400: Davao Region 10
0x800: Soccsksargen 11
0x1000: National Capital Region (NCR) 12
0x2000: Cordillera Administrative Region (CAR) 13
0x4000: Caraga 14
0x8000: Mimaropa Region 15
0x10000: Bangsamoro Autonomous Region In Muslim Mindanao (BARMM) 16
*/

export const PROVINCE_BITFLAG = [
    0x1,
    0x1,
    0x1,
    0x1,
    0x2,
    0x2,
    0x2,
    0x2,
    0x2,
    0x4,
    0x4,
    0x4,
    0x4,
    0x4,
    0x4,
    0x4,
    0x8,
    0x8,
    0x8,
    0x8,
    0x8,
    0x10,
    0x10,
    0x10,
    0x10,
    0x10,
    0x10,
    0x20,
    0x20,
    0x20,
    0x20,
    0x20,
    0x20,
    0x40,
    0x40,
    0x40,
    0x40,
    0x80,
    0x80,
    0x80,
    0x80,
    0x80,
    0x80,
    0x100,
    0x100,
    0x100,
    0x100,
    0x200,
    0x200,
    0x200,
    0x200,
    0x200,
    0x400,
    0x400,
    0x400,
    0x400,
    0x400,
    0x800,
    0x800,
    0x800,
    0x800,
    0x1000,
    0x1000,
    0x1000,
    0x1000,
    0x2000,
    0x2000,
    0x2000,
    0x2000,
    0x2000,
    0x2000,
    0x4000,
    0x4000,
    0x4000,
    0x4000,
    0x4000,
    0x8000,
    0x8000,
    0x8000,
    0x8000,
    0x8000,
    0x10000,
    0x10000,
    0x10000,
    0x10000,
    0x10000,
    0x10000,
    0x10000,
]
